import "./App.scss";
import { UserLayout } from "./Layouts/UserLayout";

export const App = () => {
  return <UserLayout />;
};
